import { render } from "./MandateRegisterCard.vue?vue&type=template&id=42f891c4"
import script from "./MandateRegisterCard.vue?vue&type=script&lang=js"
export * from "./MandateRegisterCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__